import {connect} from 'react-redux';
import {Component} from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Modal from '-/components/general/Modal';
import {authenticate} from '-/util/authenticate';
import FunnelService from '-/services/FunnelService';
import validationStyles from '-/styles/sections/validation';
import {get} from '-/util/lodash';

const styles = theme => ({
    ...validationStyles(theme)
});

class VerifyAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showErrorMsg: false,
            streetNumber: '',
            zip: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.validated === 'boolean') {
            this.setState({showErrorMsg: !nextProps.validated});
        }
    }

    // How far the member got if they leave this screen without authenticating. This is
    // the only place abandonment inside the auth step is visible - a character count,
    // never the value.
    componentWillUnmount() {
        if (this.props.validated === true) {
            return;
        }

        const {streetNumber, zip} = this.state;

        FunnelService.authFieldProgress('streetNumber', 'address', streetNumber);
        FunnelService.authFieldProgress('zip', 'address', zip);
    }

    handleStreetChange = e => {
        const streetNumber = get(e, 'target.value', '');

        this.setState({
            streetNumber
        });
    };

    handleZipChange = e => {
        const zip = get(e, 'target.value', '');

        this.setState({
            zip
        });
    };

    handleSubmit = () => {
        const {authenticate} = this.props;
        const {streetNumber, zip} = this.state;
        let formError;

        if (!streetNumber || !zip || zip.length !== 5) {
            formError = 'You must provide a valid house number before authenticating.';
            FunnelService.authFieldProgress('streetNumber', 'address', streetNumber);
            FunnelService.authFieldProgress('zip', 'address', zip);
        } else {
            const address = {
                streetNumber,
                zip
            };

            authenticate('address', address);
        }

        this.setState({
            formError
        });
    };

    handleKeyDown = e => {
        if (e.keyCode === 13) {
            this.handleSubmit();
        }
    };

    render() {
        const {validated, classes = {}} = this.props;
        const {formError, showErrorMsg, streetNumber, zip} = this.state;
        const checkClassNames = classNames(classes.verifyIcon, {
            [classes.verifyIconSuccess]: validated === true,
            [classes.verifyIconFail]: validated === false
        });

        return (
            <Modal className="verify-address" onClick={this.handleSubmit}>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <i className="fa fa-home" alt="Home" />
                        {validated !== null ? <span className={checkClassNames} /> : null}
                    </div>
                    <div>
                        <img src="../../../images/address-verification-instructions.svg" alt="House" />
                    </div>
                    <div className={classes.text}>
                        <h3>Verify Address</h3>
                        {formError && <h4 className={classes.errorText}>{formError}</h4>}
                        {showErrorMsg ? (
                            <h4 className={classes.errorText}>Your address number or zip doesn&#8217;t match what we have on file.</h4>
                        ) : null}
                    </div>
                </section>
                <div className="masked-form">
                    <div className={classes.control}>
                        <div className={classes.accountInput}>
                            <input
                                value={streetNumber}
                                onChange={this.handleStreetChange}
                                placeholder="House #"
                                autoComplete="off"
                                onKeyDown={this.handleKeyDown} />
                            <input
                                value={zip}
                                onChange={this.handleZipChange}
                                placeholder="Zip Code"
                                maxLength="5"
                                autoComplete="off"
                                onKeyDown={this.handleKeyDown} />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const {validated} = state.validationInfo;
    return {validated};
};

export default connect(mapStateToProps, {authenticate})(injectSheet(styles)(VerifyAddress));
